import { Sprite, Assets } from 'pixi.js'

export default class objBg {
    constructor(app, container) {
        this.app = app
        this.container = container
        this.imgid = ''

        this.bgSprite = null

        this.init()
    }

    init() {
        this.setChara()
    }

    //キャラクター選択
    setChara() {
        const charaitem = [...document.querySelectorAll('.js-ques-chara')]

        charaitem.forEach((el) => {
            el.addEventListener('click', () => {
                charaitem.forEach((e) => {
                    if (e.classList.contains('-active')) {
                        e.classList.remove('-active')
                    }
                })

                const chara = el.getAttribute('data-chara')
                const charaid = el.getAttribute('data-index')
                const imgnum = el.getAttribute('data-imgnum') //画像の数
                MAIN.data.character = chara
                MAIN.data.characterid = charaid
                MAIN.data.bestimgnum = imgnum
                
                el.classList.add('-active')

                MAIN.pagination.activeOkBtn()
            })
        })
    }

    resetChara() {
        const charaitem = [...document.querySelectorAll('.js-ques-chara')]

        charaitem.forEach((e) => {
            if (e.classList.contains('-active')) {
                e.classList.remove('-active')
            }
        })
    }

    //画像ロード配置
    async setBgimg() {
        const character = MAIN.data.character
        const bestimgid = MAIN.data.bestimgid

        if (this.container.children.length > 0) {
            this.container.removeChildAt(0)
        }

        const bgImage = await Assets.load(`/oshigatari/assets/img/generator/bg/${character}/ph_${bestimgid}.png`)

        this.bgSprite = new Sprite(bgImage)

        this.bgSprite.width = this.app.renderer.width
        this.bgSprite.height = this.app.renderer.height
        this.bgSprite.zIndex = -1

        this.container.addChild(this.bgSprite)
    }

    //画像があれば削除する
    removeSprite() {
        if (this.bgSprite) {
            this.container.removeChild(this.bgSprite)
            delete this.bgSprite
        }
    }
}
